import React from 'react'
import { Row } from 'antd'
import TreeFilter from 'components/TreeSelectFilter'

const DegreeDepartmentFilter = ({
  filterOptions,
  filterValues,
  handleFilterChange,
  handleFilterSearch,
  
}) => {
  return (
    <Row style={{rowGap: '0px !important' }}>
      <TreeFilter
        width = "60%"
        label="Degree"
        placeholder="Select Degree"
        treeData={filterOptions?.degreeList}
        value={filterValues?.selectedDegrees}
        onChange={handleFilterChange}
        onSearch={handleFilterSearch}
        valueKey='selectedDegrees'
      />
      <TreeFilter
        width = "60%"
        label="Department"
        placeholder="Select Department"
        treeData={filterOptions?.departList}
        value={filterValues?.selectedDepartments}
        onChange={handleFilterChange}
        onSearch={handleFilterSearch}
        disabled={filterValues?.selectedDegrees?.length === 0}
        valueKey='selectedDepartments'
      />
      <TreeFilter
        width = "60%"
        label="Specialization"
        placeholder="Select Specialization"
        treeData={filterOptions?.splList}
        value={filterValues?.selectedSpecializations}
        onChange={handleFilterChange}
        disabled={filterValues?.selectedDepartments?.length === 0}
        valueKey='selectedSpecializations'
      />
    </Row>
  )
}

export default DegreeDepartmentFilter
